import { Assets, Rectangle, Texture } from "pixi.js";

const textureNames = [
	'bunny',
	'bear',
	'snake',
	'spider',
	'bird',
] as const;
type TextureName = typeof textureNames[number];

const sheetDefs = {
	'bees': {tileSize: 16},
	'ground': {tileSize: 32},
};
type SheetName = keyof typeof sheetDefs;

export const Textures: Record<TextureName, Texture> = ({} as any);
export const Sheets: Record<SheetName, Texture[]> = ({} as any);

function tile(sheet: Texture, x: number, y: number, w: number, h: number) {
	return new Texture({
		source: sheet.source,
		frame: new Rectangle(x, y, w, h)
	});
}

export async function loadTextures() {
	for (const name of textureNames) {
		Assets.add({alias: name, src: `./assets/${name}.png`});
	}
	for (const name of Object.keys(sheetDefs)) {
		Assets.add({alias: name, src: `./assets/${name}.png`});
	}
	const textures: Record<TextureName | SheetName, Texture> = await Assets.load([...textureNames, ...Object.keys(sheetDefs)]);
	for (const name of textureNames) {
		Textures[name] = textures[name];
	}
	for (const name of (Object.keys(sheetDefs) as SheetName[])) {
		Sheets[name] = [];
		const {tileSize} = sheetDefs[name];
		for (let i = 0; i < textures[name].width / tileSize; i++) {
			Sheets[name].push(tile(textures[name], i * tileSize, 0, tileSize, tileSize))
		}
	}
}

